export default "__VITE_ASSET__D9vLeb26__"